import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Amplify Demo
        </p>
        <a
          className="App-link"
          href="https://www.pakke.mx"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visita pakke.mx!
        </a>
      </header>
    </div>
  );
}

export default App;
